import DealerKit from "../../js/api";
let taxRates = undefined;
async function getTaxRates() {
    if (!taxRates) {
        await DealerKit.accounting.getTaxRates().then(response => {
            taxRates = response.data.data;
        });
    }
    return taxRates;
}
export { getTaxRates };
